export default {
  brand: {
    name: 'VILLAGARAGE',
    tagline: 'Premium Garage Systems',
  },
  nav: {
    home: 'Главная',
    garage: 'Гаражные системы',
    villa: 'Проекты вилл',
    winter: 'Зимний сад',
    projects: 'Проекты',
    about: 'О нас',
    contact: 'Контакты',
    dealer: 'Дилерство и Партнёрство',
    login: 'Вход для участников / дилеров',
    cta: 'Получить предложение для вашего проекта',
  },
  hero: {
    title1: 'Премиальные гаражные системы,',
    title2: 'которые повышают ценность вашей виллы',
    subtitle: 'Архитектурно проработанные премиальные закрытые гаражные решения для роскошных вилл и частных домов.',
    cta1: 'Получить предложение для вашего проекта',
    cta2: 'Ознакомиться с гаражными системами',
    small: 'Системы на 1 и 2 автомобиля • Индивидуальный дизайн • Решения под проект',
  },
  s1: {
    title: 'Гараж не должен быть запоздалым дополнением к вилле.',
    text: 'VILLAGARAGE рассматривает гараж не как отдельное строение, а как неотъемлемую часть архитектуры виллы.',
    f1: 'Индивидуальный архитектурный дизайн',
    f2: 'Премиальный внешний вид',
    f3: 'Всесезонная защита автомобиля',
  },
  s2: {
    title: 'Та же вилла. Другой уровень жизни.',
    openTitle: 'Открытая парковка',
    openDesc: 'Автомобиль под открытым небом. Нет архитектурной целостности. Не добавляет ценности проекту.',
    garageTitle: 'Премиальный гараж VILLAGARAGE',
    garageDesc: 'Автомобиль защищён круглый год. Интегрируется с архитектурой виллы. Повышает премиальную ценность проекта.',
    cta: 'Запросить решение для вашего проекта',
  },
  s3: {
    title: 'Гаражные системы',
    cta: 'Подробнее',
    card1: {
      title: 'Премиальный гараж на один автомобиль',
      desc: 'Компактный, элегантный, архитектурно проработанный премиальный гараж для одного автомобиля.',
    },
    card2: {
      title: 'Премиальный гараж на два автомобиля',
      desc: 'Просторный, светлый премиальный гараж, органично вписывающийся в вашу виллу, для двух автомобилей.',
    },
    card3: {
      title: 'Гаражные системы под проект',
      desc: 'Индивидуальные решения, разработанные под проекты вилл и особые требования.',
    },
  },
  s4: {
    title1: 'Не бывает двух одинаковых вилл.',
    title2: 'Их гаражи тоже не должны быть одинаковыми.',
    d1: 'Антрацитовые архитектурные системы',
    d2: 'Детали из натурального дерева',
    d3: 'Архитектурное освещение',
    d4: 'Индивидуальные фасадные решения',
    d5: 'Решения на 1 и 2 автомобиля',
  },
  s5: {
    title: 'Деталь, выделяющая проекты вилл из стандарта',
    subtitle: 'VILLAGARAGE для строительных компаний, девелоперов и архитекторов.',
    b1: 'Дизайн под конкретный проект',
    b2: 'Интеграция с архитектурой виллы',
    b3: 'Конструкция для проектов с несколькими виллами',
    b4: 'Премиальное восприятие проекта',
    b5: 'Решения на один / два автомобиля',
    b6: 'Системный подход как альтернатива традиционному тяжёлому строительству',
    cta: 'Отправить ваш проект виллы',
  },
  s6: {
    title: 'Не оставляйте свой дорогой автомобиль под открытым небом.',
    text: 'Создайте более защищённое премиальное пространство от солнца, дождя, града, снега и внешних факторов.',
    cta: 'Хочу гараж для своей виллы',
  },
  s7: {
    title: 'Целостные архитектурные решения для вашей виллы',
    subtitle: 'Премиальный гараж + Зимний сад',
    cta: 'Запросить информацию о моём проекте',
  },
  s8: {
    title: 'С чего начинается ваш проект?',
    step1: 'Поделитесь участком',
    step1d: 'Отправьте нам основные сведения о вашей вилле или проекте.',
    step2: 'Определим потребность',
    step2d: 'Давайте вместе уточним вместимость и сценарии использования.',
    step3: 'Подход к дизайну',
    step3d: 'Давайте разработаем индивидуальный дизайн, подходящий вашей архитектуре.',
    step4: 'Предложение',
    step4d: 'Давайте подготовим индивидуальное предложение исходя из объёма проекта.',
    step5: 'Реализация',
    step5d: 'После утверждения проведём реализацию по плану.',
  },
  s9: {
    title: 'Вдохновляющие гаражные проекты',
    filterAll: 'Все',
    filterSingle: 'На один автомобиль',
    filterDouble: 'На два автомобиля',
    filterVilla: 'Проекты вилл',
    filterWinter: 'Зимний сад',
  },
  s10: {
    title: 'Давайте спроектируем индивидуальное решение для вашей виллы или проекта.',
  },
  form: {
    name: 'Полное имя',
    namePh: 'Ваше полное имя',
    phone: 'Телефон',
    phonePh: '+90 5xx xxx xx xx',
    email: 'Эл. почта',
    emailPh: 'example@email.com',
    city: 'Город',
    cityPh: 'Ваш город',
    customerType: 'Тип клиента',
    solution: 'Интересующее решение',
    projectStatus: 'Статус проекта / участка',
    message: 'Сообщение',
    messagePh: 'Кратко опишите ваш проект...',
    upload: 'Загрузка изображения',
    uploadHint: 'Вы можете загрузить изображения участка, виллы или референсы',
    submit: 'ОТПРАВИТЬ МОЙ ПРОЕКТ',
    success: 'Ваш запрос получен. Мы свяжемся с вами в ближайшее время.',
    error: 'Что-то пошло не так. Пожалуйста, попробуйте ещё раз.',
    customer: {
      villaOwner: 'Владелец виллы',
      construction: 'Строительная компания',
      developer: 'Девелопер',
      architect: 'Архитектор',
      investor: 'Инвестор',
      other: 'Другое',
    },
    solutionOpt: {
      single: 'Гараж на один автомобиль',
      double: 'Гараж на два автомобиля',
      villaProject: 'Проект виллы',
      winterGarden: 'Зимний сад',
      combined: 'Гараж + Зимний сад',
      custom: 'Особый проект',
    },
    status: {
      land: 'Есть участок / земля',
      construction: 'Вилла строится',
      existing: 'Существующая вилла',
      none: 'Участка пока нет',
      other: 'Другое',
    },
  },
  whatsapp: {
    message: 'Здравствуйте, VILLAGARAGE, я хочу получить информацию и предложение по проекту виллы / гаража.',
  },
  mobile: {
    cta: 'Запросить информацию о вашем проекте',
  },
  faq: {
    title: 'Часто задаваемые вопросы',
    q1: 'Можно ли применить к существующим виллам?',
    a1: 'Да. Мы предлагаем решения как для новых, так и для существующих вилл. Для существующих вилл реализация выполняется индивидуально после оценки участка и архитектурной конструкции.',
    q2: 'Есть ли системы на один и два автомобиля?',
    a2: 'Да, доступны наши премиальные гаражные системы на один и два автомобиля. Мы также разрабатываем индивидуальные многофункциональные решения.',
    q3: 'Применяется ли одна модель ко всем виллам?',
    a3: 'Нет. Каждый проект разрабатывается индивидуально с учётом архитектуры, размеров и потребностей клиента; стандартная модель не используется.',
    q4: 'Работаете ли вы над проектами с несколькими виллами?',
    a4: 'Да, мы сотрудничаем со строительными компаниями и девелоперами над проектами с несколькими виллами, предлагая индивидуальные решения.',
    q5: 'Можно ли также построить зимний сад?',
    a5: 'Да. Помимо гаражных систем, мы предлагаем зимние сады и интегрированные решения «гараж + зимний сад».',
    q6: 'Как определяется цена?',
    a6: 'Цена определяется исходя из размеров, вместимости автомобилей, архитектурных деталей, предпочтений по материалам и объёма проекта.',
    q7: 'Как я могу отправить свой проект?',
    a7: 'Вы можете заполнить форму на нашем сайте, связаться через WhatsApp (+90 542 799 47 89) или отправить сообщение через Instagram (@villagarage90).',
  },
  about: {
    title: 'О нас',
    text: 'VILLAGARAGE — бренд, разрабатывающий архитектурные решения для премиальных гаражей вилл и уличных жилых пространств. Он рассматривает гараж не как отдельное строение, а как неотъемлемую часть архитектуры виллы, добавляя жилым пространствам долговременную ценность благодаря антрацитовым системам, деталям из натурального дерева и индивидуальным фасадным решениям. Работая с владельцами вилл, архитекторами, подрядчиками и девелоперами, бренд предлагает премиальные решения, адаптированные под каждую потребность и интегрированные с архитектурой.',
  },
  final: {
    title: 'Завершите архитектуру вашей виллы гаражом.',
    cta1: 'Получить предложение для вашего проекта',
    cta2: 'Связаться с нами в WhatsApp',
  },
  roles: {
    member: 'Обычный участник',
    dealer_a: 'Дилер класса A',
    dealer_b: 'Дилер класса B',
    dealer_c: 'Дилер класса C',
    distributor: 'Дистрибьютор',
    architect: 'Архитектор',
    construction: 'Строительная компания',
    realtor: 'Риелтор',
    admin: 'Администратор',
  },
  catalog: {
    title: 'Гаражные системы',
    all: 'Все',
    cat: {
      standard: 'Стандартные гаражи',
      custom: 'Гаражи на заказ',
      luxury: 'Люксовые гаражи',
    },
    tag: {
      new: 'Новинка',
      single: 'На один автомобиль',
      double: 'На два автомобиля',
      premium: 'Премиум',
      project: 'Под проект',
    },
    capacityLabel: 'Вместимость',
    singleCar: '1 автомобиль',
    doubleCar: '2 автомобиля',
    multiCar: 'Несколько автомобилей',
    quote: 'Запросить цену',
    details: 'Подробнее',
    addToCart: 'В корзину',
    projectQuote: 'Создать предложение под проект',
    from: 'От',
    priceOnRequest: 'Запросите цену',
    empty: 'В этой категории пока нет товаров.',
    p1: { desc: 'Компактный, элегантный, архитектурно проработанный премиальный гараж для одного автомобиля.' },
    p2: { desc: 'Просторный, светлый премиальный гараж, органично вписывающийся в вашу виллу, для двух автомобилей.' },
    p3: { desc: 'Индивидуальный гараж на один автомобиль, спроектированный для вашей виллы и интегрированный с её архитектурой.' },
    p4: { desc: 'Индивидуально спроектированное архитектурное решение гаража на два автомобиля.' },
    p5: { desc: 'Люксовый гараж для виллы с материалами и деталями высшего класса.' },
    p6: { desc: 'Гаражные системы под конкретный проект для застройки с несколькими виллами.' },
  },
  currency: {
    label: 'Валюта',
    planned: 'Скоро',
  },
  auth: {
    title: 'Вход для участников / дилеров',
    subtitle: 'Доступ к вашей панели и ценам по вашей роли.',
    email: 'Эл. почта',
    password: 'Пароль',
    submit: 'Войти',
    note: 'Безопасный вход и ролевая авторизация станут доступны после подключения бэкенда.',
    comingSoon: 'Слой входа готов. Этот экран станет активным после завершения безопасного подключения к бэкенду.',
    roleInfoTitle: 'Доступ по ролям',
    roleInfoText: 'Поддерживаются роли: обычный участник, дилеры класса A/B/C, дистрибьютор, архитектор, строительная компания, риелтор и администратор. Каждая роль видит только разрешённые разделы; авторизация применяется на сервере.',
    applyCta: 'Подать заявку на дилерство и партнёрство',
    backHome: 'На главную',
  },
  dealer: {
    badge: 'Партнёрская сеть',
    heroTitle: 'Присоединяйтесь к партнёрской сети VILLAGARAGE',
    heroSubtitle: 'Предложите премиальные гаражные системы VILLAGARAGE своим клиентам в Турции и на международных рынках.',
    heroCta: 'Подать заявку',
    modelsTitle: 'Модели членства и дилерства',
    modelsSubtitle: 'Структура для каждого уровня — от частных клиентов до профессиональных дилеров.',
    cardCta: 'Подробнее и заявка',
    models: {
      standard: { name: 'Стандартное членство', desc: 'Базовая программа для частных клиентов и обычных участников.' },
      a: { name: 'Дилерство класса A', desc: 'Самая полная модель дилерства. Скидки, квота, залог и преимущества оплаты определяет администратор.' },
      b: { name: 'Дилерство класса B', desc: 'Сбалансированная модель партнёрства для дилеров среднего масштаба.' },
      c: { name: 'Дилерство класса C', desc: 'Начальная модель партнёрства для новых дилеров.' },
    },
    proTitle: 'Профессиональное партнёрство',
    proSubtitle: 'Гибкая модель партнёрства для профессионалов, приводящих проекты и клиентов.',
    proSectors: 'Архитекторы • Строительные компании • Риелторы • Дистрибьюторы',
    partnerCta: 'Стать партнёром',
    partnersTitle: 'Модели партнёрства',
    partners: {
      distributor: 'Дистрибьютор',
      architect: 'Архитектор',
      construction: 'Строительная компания',
      realtor: 'Риелтор',
      other: 'Другой партнёр',
    },
    partnersNote: 'Без дилерской квоты и залога; каждая группа получает свою скидку, ценовое преимущество и уровень доступа.',
    termsTitle: 'Условия по классам',
    termsText: 'Скидки, квоты закупок, суммы залога и преимущества оплаты определяются отдельно для каждого класса дилерства и управляются из админ-панели. Эти значения на данный момент не фиксированы.',
    rolesTitle: 'Структура ролей',
    rolesSubtitle: 'Каждый пользователь видит только разрешённые его ролью разделы; авторизация применяется на сервере после подключения безопасного бэкенда.',
    form: {
      title: 'Форма заявки',
      subtitle: 'Заполните форму ниже; ваша заявка будет принята на рассмотрение.',
      name: 'Полное имя',
      company: 'Название компании',
      phone: 'Телефон',
      email: 'Эл. почта',
      country: 'Страна',
      city: 'Город',
      website: 'Веб-сайт',
      instagram: 'Instagram',
      field: 'Сфера деятельности',
      applicationType: 'Тип заявки',
      selectPlaceholder: 'Выбрать',
      howToWork: 'Как вы хотите работать с VILLAGARAGE?',
      messagePh: 'Расскажите коротко...',
      submit: 'Отправить заявку',
      success: 'Ваша заявка принята на рассмотрение.',
      error: 'Что-то пошло не так. Попробуйте снова.',
    },
  },
  footer: {
    tagline: 'Premium Garage Systems',
    navTitle: 'Меню',
    contactTitle: 'Контакты',
    instagram: 'Instagram',
    copyright: 'Все права защищены.',
  },
};